import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";
import { HeaderGroup, Row } from "react-table";

import { CaseDocumentWithPresignedUrl } from "pwapi";

import SubTable from "components/admin/table/SubTable";
import Table from "components/admin/table/Table";

import TableRow from "../ViewerListsTableView/TableRow";

type ReportListViewProps = {
  headerGroups: HeaderGroup<any>[];
  rows: Row<any>[];
  prepareRow: Function;
  reportType: "report" | "requisition";
  renderRowSubComponent: Function;
};

const ReportListView = ({
  headerGroups,
  rows,
  prepareRow,
  reportType,
  renderRowSubComponent,
}: ReportListViewProps) => {
  return (
    <Table
      className="DocumentTable"
      headerGroups={headerGroups.map((headerGroup, index) => (
        <tr {...headerGroup.getHeaderGroupProps()} key={index}>
          {headerGroup.headers.map((column: any) => (
            <th
              {...column.getHeaderProps(column.getSortByToggleProps())}
              className="Headers__cell"
              key={`column:${column.id}`}
            >
              {column.render("Header")}
              <span>
                {column.isSorted ? (
                  column.isSortedDesc ? (
                    <FontAwesomeIcon icon="angle-down" />
                  ) : (
                    <FontAwesomeIcon icon="angle-up" />
                  )
                ) : (
                  ""
                )}
              </span>
            </th>
          ))}
        </tr>
      ))}
      rows={rows.map((row) => {
        prepareRow(row);
        let document: any | undefined = row.original.case_document_views.find(
          (doc: CaseDocumentWithPresignedUrl) =>
            reportType === "report"
              ? doc.category ===
                CaseDocumentWithPresignedUrl.category.CASE_REPORT
              : doc.category ===
                  CaseDocumentWithPresignedUrl.category.REQUISITION_FORM &&
                doc.status !== CaseDocumentWithPresignedUrl.status.PENDING
        ) as any;

        return (
          <Fragment
            {...row.getToggleRowExpandedProps}
            key={`case:${row.original.id}`}
          >
            <TableRow
              row={row}
              isUnviewed={document && !document.has_been_viewed}
            />
            {row.isExpanded && (
              <SubTable>{renderRowSubComponent({ row })}</SubTable>
            )}
          </Fragment>
        );
      })}
    />
  );
};

export default ReportListView;
